export default __webpack_public_path__ + "static/media/a9.449c7bda.png";